<div
  [class.loading-spinner-container]="!inline"
  [class.full-page]="fullPage && !inline"
  [class.d-inline-block]="inline">
  <div class="spinner-border" [ngClass]="textClass" [class.spinner-border-sm]="inline" role="status"></div>
  @if (message && !inline) {
    <p>{{ message }}</p>
  }
</div>
